import {useCallback} from 'react';
import {isOfflineQueuedResult} from 'src/offline/offlineMutation';
import {useTransitionTaskAssignmentMutation} from 'src/redux/queries/taskAssignment';

export interface PostTransitionArgs {
  transition: string;
  note: string;
  occurredAt: string;
}

/**
 * `postTransition` for FormTransitionBar: posts an assignment transition through
 * the outbox-aware mutation so it queues, with its field time, while offline.
 */
export const useTaskAssignmentTransition = (
  assignmentId: number | undefined
): ((args: PostTransitionArgs) => Promise<{offlineQueued?: boolean}>) => {
  const [transitionTaskAssignment] = useTransitionTaskAssignmentMutation();

  return useCallback(
    async ({transition, note, occurredAt}: PostTransitionArgs) => {
      if (assignmentId === undefined) return {};
      const result = await transitionTaskAssignment({
        assignmentId,
        transition,
        note,
        occurredAt,
      }).unwrap();
      return {offlineQueued: isOfflineQueuedResult(result)};
    },
    [assignmentId, transitionTaskAssignment]
  );
};
